/* global storedItem, currentClass, code */
'use strict';
var rememberText = {
    idType: '記住身分證字號',
    acctType: '記住帳號',
};

function maskNationalID(value) {
    return value.slice(0, value.length - 4) + '****';
}

function checkShowLoginButton() {
    var currentForm = $('.' + currentClass + '-login');
    // 若驗證碼區塊有顯示，則需輸入滿 4 碼
    var captchaSection = currentForm.find('.captcha-section');
    var captchaInvalid =
        captchaSection.length > 0 &&
        !captchaSection.hasClass('hidden') &&
        currentForm.find('.captcha-result').val().length !== 4;

    if (code == '-1001' || $('.' + currentClass + '-login .password').val().length < 6 || captchaInvalid ) {
        $('.' + currentClass + '-login [name=button]').prop('disabled', true);
    } else {
        $('.' + currentClass + '-login [name=button]').prop('disabled', false);
    }
}

$(function () {
    //show SweetAlert
    if (
        $('#NewPinInfo_Message').val() ||
        $('#NewPinInfo_RedirectUri').val() ||
        $('#NewPinInfo_DetailMessage').val()
    ) {
        const newPinMessage = $('#NewPinInfo_Message').val();
        const redirectUri = $('#NewPinInfo_RedirectUri').val();
        const detailMessage = $('#NewPinInfo_DetailMessage').val();
        const loginUri = new URLSearchParams(redirectUri).get('redirectUrl');
        const systemId = $('#SystemId').val();

        if (detailMessage && !newPinMessage) {
            showInfoAlert(detailMessage).then(() => {
                fetch('/Account/CompleteLogin', {
                    method: 'POST',
                    headers: {
                        'RequestVerificationToken': $('[name=__RequestVerificationToken]').val()
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success && data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else {
                            alert(data.error || '操作失敗');
                        }
                    })
                    .catch(() => {
                        alert('網路錯誤，請稍後再試');
                    });
            });
        } else if (!detailMessage && newPinMessage) {
            changePwdAlert(newPinMessage, redirectUri, systemId);
        } else if (detailMessage && newPinMessage) {
            showInfoAlert(detailMessage).then(() =>
                changePwdAlert(newPinMessage, redirectUri, systemId),
            );
        }
    }

    let branchID = null;
    const systemId = encodeURIComponent($('#SystemId').val());
    if (storedItem) {
        storedItem = JSON.parse(storedItem);
        currentClass = storedItem.type;
        branchID = storedItem.branchID;
        switchTo(currentClass, false);

        if (currentClass === 'account') {
            $('.' + currentClass + '-login')
                .find('.fakeUserName')
                .val(storedItem.user);
            $('#id-rememberLogin').prop('checked', false);
            $('#account-rememberLogin').prop('checked', true);
            let setVal = branchID + storedItem.user;
            $('.account-login #UserName').val(setVal);
            $('.account-password').focus();
        } else if (currentClass === 'id') {
            $('.id-login').find('.fakeUserName').val(maskNationalID(storedItem.user));
            $('.id-login').find('.NationalId').val(storedItem.user);
            $('#id-rememberLogin').prop('checked', true);
            $('#account-rememberLogin').prop('checked', false);
            $('.id-login').find('.password').focus();
        }
    } else {
        $('.id-login .fakeUserName').focus();
    }

    function switchTo(type, isFocus) {
        let tabName = '.' + type + '-login';
        $('.id-login, .account-login').removeClass('active');
        $('.tab-section .tab').removeClass('active');
        $(tabName).addClass('active');
        $("div[data-tab='." + type + "-login']").addClass('active');
        if (isFocus) {
            $(`.${type}-login .fakeUserName`).focus();
        }
        currentClass = type;
        //$('.remember-text').html(rememberText[type == 'account' ? 'acctType' : 'idType']);
        checkShowLoginButton();
    }

    $('.tab-section .tab').click(function () {
        let tabName = encodeURIComponent($(this).attr('data-tab'));
        currentClass = tabName.split('-')[0].slice(1);
        switchTo(currentClass, true);
    });

    var html = '<option value="884L">884L 國際業務分公司</option>';
    $('.account-login select').html(html);

    $('.id-login,.account-login').on('submit', function (e) {
        $('.loading-box').removeClass('d-none');
        // setTimeout(function () {
        //     $('.loading-box').addClass('d-none');
        // }, 10000);
        var isRememberLogin = $(`#${currentClass}-rememberLogin`).prop('checked');
        if (isRememberLogin) {
            var user =
                currentClass === 'id'
                    ? $('.id-login .NationalId').val()
                    : $(this).find('.fakeUserName').val();
            var storedObj = {
                type: currentClass,
                user: user,
            };

            if (currentClass === 'account') {
                storedObj.branchID = $('.account-login select').val();
            }

            localStorage.setItem(KEY, JSON.stringify(storedObj));
        } else {
            localStorage.removeItem(KEY);
        }
        return true;
    });

    $('.id-login .fakeUserName')
        .on('keyup keypress', function (e) {
            $(this).val($(this).val().toUpperCase());
            var nationalID = $(this).val();
            $('.invalid-feedback').html('').removeClass('d-block');

            if (e.keyCode == 13) {
                e.preventDefault();
                $('.id-login select').focus();
                return;
            }
        })
        .on('focus', function (e) {
            var value = $('.id-login .NationalId').val();
            if (value) {
                $(this).val(value);
            }
        })
        .on('blur', function (e) {
            var value = $(this).val().toUpperCase();
            if (value) {
                $('.id-login .NationalId').val(value);
                $(this).val(value.slice(0, value.length - 4) + '****');
            }
        });

    // account part
    $('.account-login #fakeUserName, .account-login select').on('change', function () {
        let setVal = $('.account-login select').val() + $('.account-login #fakeUserName').val();
        $('.account-login #UserName').val(setVal);
    });

    // account login
    $('.fakeUserName').on('keyup change', function (e) {
        $(this).val($(this).val().toUpperCase());
    });

    $('select').on('change', function (e) {
        checkShowLoginButton();
    });

    // disable/active submit button
    $('.id-login .password').on('keyup change', function (e) {
        checkShowLoginButton();
    });

    // disable/active submit button
    $('.account-login .password').on('keyup change', function (e) {
        checkShowLoginButton();
    });

    // 驗證碼輸入時重新檢查登入按鈕狀態
    $('.captcha-result').on('keyup change', function (e) {
        checkShowLoginButton();
    });

    function showInfoAlert(detailMessage) {
        return Swal.fire({
            title: '',
            text: detailMessage,
            icon: 'info',
            allowOutsideClick: false,
            confirmButtonColor: '#00a99d',
            confirmButtonText: '確定',
        });
    }

    function changePwdAlert(newPinMessage, redirectUri, systemId) {
        Swal.fire({
            title: '',
            text: newPinMessage,
            icon: 'warning',
            allowOutsideClick: false,
            showDenyButton: true,
            confirmButtonColor: '#00a99d',
            confirmButtonText: '變更新密碼',
            denyButtonColor: '#e5e5e5',
            denyButtonText: '沿用原密碼',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                //redirect to reset pwd
                window.location.href = redirectUri.toString();
            } else if (result.isDenied) {
                //call extend warning api
                fetch('/Account/ExtendResetPwdWarning', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'RequestVerificationToken': $('[name=__RequestVerificationToken]').val()
                    },
                    body: JSON.stringify({
                        acct: '',
                        systemId: systemId,
                    }),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            if (data.redirectUrl) {
                                // 有重定向 URL，表示已自動完成登入
                                window.location.href = data.redirectUrl;
                            } else {
                                // 一般情況，顯示成功訊息
                                alert(data.message);
                            }
                        } else {
                            alert(data.error || '操作失敗');
                        }
                    })
                    .catch(error => {
                        alert('網路錯誤，請稍後再試');
                    });
            }
        });
    }

    // 檢查錯誤代碼並顯示相應的錯誤訊息

    if (code) {
        switch (code) {
            case 'user_not_exist':
                showAlert('帳號已停用', 'error', '您的帳號已被停用或不存在，請聯繫管理員。');
                break;
            case 'login_suspended':
                showAlert('系統維護中', 'info', '親愛的用戶您好，系統進行維護作業中，將暫停登入，如有造成不便請見諒。。');
                break;
            case 'need_warning_change_pwd':
                showAlert('請修改密碼', 'warning', '親愛的用戶，您的交易密碼已使用超過 3 個月，為了安全性考量，建議您儘速變更新密碼。');
                break;
            case 'SESSION_EXPIRED':
                showAlert('登入逾時', 'info', '您的登入階段已過期，請重新登入。');
                break;
            case 'AUTH_FAILED':
                showAlert('驗證失敗', 'error', '登入驗證失敗，請重新登入。');
                break;
        }
    }
});

function showAlert(title, icon, message) {
    return Swal.fire({
        title: title,
        text: message,
        icon: icon,
        allowOutsideClick: false,
        confirmButtonColor: '#00a99d',
        confirmButtonText: '確定',
    });
}
